<template>
  <el-carousel :interval="4000" type="card" height="370px">
    <el-carousel-item v-for="(item,index) in List" :key="index">
       <img :src="item.src" width="100%">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
    data(){
        return{
            List:[
                {src:require("../../assets/image/jiameng/banner2.jpg")},
                {src:require("../../assets/image/jiameng/banner3.jpg")},
                {src:require("../../assets/image/jiameng/banner4.jpg")},
                {src:require("../../assets/image/jiameng/banner5.jpg")},
                {src:require("../../assets/image/jiameng/banner6.jpg")},
            ]
        }
    }
}
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>


// WEBPACK FOOTER //
// src/components/common/carousel.vue